import { render, staticRenderFns } from "./pointsDetails.vue?vue&type=template&id=01a448ae&scoped=true&"
import script from "./pointsDetails.vue?vue&type=script&lang=js&"
export * from "./pointsDetails.vue?vue&type=script&lang=js&"
import style0 from "./pointsDetails.vue?vue&type=style&index=0&id=01a448ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a448ae",
  null
  
)

export default component.exports